import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import UpcomingClassLanguage from '../../../../Statistic/UpcomingClassLanguage'
import Icon from '../../../../../../components/UI/Icon'
import MultiTalent from '../../../../../../components/Shared/MultiTalent'

import {
  deleteClassBanner,
  editClassBanner,
} from '../../../../../../routing/fetchingfunction/user/user.action'
import {
  selectLoadingEditClassBanner,
  selectRole,
  selectUserData,
} from '../../../../../../routing/fetchingfunction/user/user.reducer'

import { useUserName } from '../../../../../../hooks'

import { classLevels, imagePrefix } from '../../../../../../constants'

const ClassBannersActiveBanner = ({ classBanner }) => {
  const dispatch = useDispatch()

  const role = useSelector(selectRole)
  const userData = useSelector(selectUserData)
  const activateLoading = useSelector(selectLoadingEditClassBanner)

  const [isDeleteLoading, setIsDeleteLoading] = useState(false)

  const userName = useUserName()

  const classLevel =
    classLevels.find((level) => level.value === classBanner.class_banner_level) || classLevels[2]

  const handleToggleActive = () => {
    const data = new FormData()
    data.set(
      'class_banner',
      JSON.stringify({
        active: !classBanner.active,
        payment_preferences: classBanner.payment_preferences.map((preference) => preference.id),
        class_banner_category: classBanner.class_banner_category.id,
        description: classBanner.description,
        price_per_class: classBanner.price_per_class,
        keywords: classBanner.keywords,
        is_public: classBanner.is_public,
      })
    )

    dispatch(
      editClassBanner({
        id: classBanner.classbanner_hash_1,
        data,
      })
    )
  }

  const handleDelete = () => {
    setIsDeleteLoading(true)

    dispatch(deleteClassBanner(classBanner.classbanner_hash_1)).then(() => {
      setIsDeleteLoading(false)
    })
  }

  const languagesContent = userData.profile.languages.map((language) => {
    return <UpcomingClassLanguage key={language} language={language} />
  })

  const currenciesContent = classBanner.payment_preferences.map((currency) => {
    return (
      <li key={currency.id} className="flex w-[20px] h-[20px]">
        <img
          src={`/assets/icon/${currency.slug}-icon.svg`}
          alt={currency.name}
          title={currency.name}
          className="w-full h-full"
        />
      </li>
    )
  })
  return (
    <div className="w-full bg-[#FEEBDD] rounded-[10px] flex flex-col items-center p-[10px] border-[#F79009] border-[1px]">
      <div className="w-full flex items-center">
        <div className="relative w-[354px] h-[254px]">
          <video className="w-full h-full rounded-[6px] object-fill" controls>
            <source src={`${imagePrefix}${classBanner.cover_video}`} type="video/mp4" />
          </video>
        </div>

        <div className="min-h-[254px] bg-[#fff5ee] border-[#ffca84] border-[1px] rounded-[6px] ml-[10px] flex-1 px-[20px] py-[10px]">
          <div className="w-full border-b-[#f674432b] border-b-[1px] flex items-center pb-[10px]">
            <span className="text-base font-semibold text-[#F67443]">
              {classBanner.class_banner_category.name}
            </span>

            <span className="flex items-center text-center text-[#F79009] font-semibold text-xs ml-[10px] mr-[18px] px-[8px] border-[#F79009] border-[1px] rounded-[8px] h-[24px]">
              {classLevel.label}
            </span>

            <div className="ml-auto flex justify-center gap-x-[16px]">
              <div className="flex justify-center items-center">
                <img
                  className="w-[16px] h-[16px]"
                  src={'/assets/icon/checkbox-multiple-line.svg'}
                  alt="Checkbox"
                />

                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.total_bookings || 0}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[16px] h-[16px]" src={'/assets/icon/user-green.svg'} alt="User" />

                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.total_students || 0}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[16px] h-[16px]" src={'/assets/icon/star.svg'} alt="Star" />
                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.overall_rating_average || 0}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <span className="text-[#B733DD] text-xs font-bold">ROI</span>
                <span className="text-[#F67443] font-medium ml-1 text-xs">
                  {classBanner.tutor_stats?.roi || 0}%
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img
                  className="w-[16px] h-[16px]"
                  src={'/assets/icon/euro-coin.svg'}
                  alt="Euro coin"
                />
                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.price_per_class || 0}
                </span>
              </div>
            </div>
          </div>

          <div className="w-full flex items-start justify-between mt-[10px]">
            <div className="w-full">
              <div className="flex items-center">
                <h4 className="text-2xl font-bold text-[#F67443] mr-[10px]">{userName}</h4>

                {classBanner.multitalent && <MultiTalent />}
              </div>

              <p className="mt-[8px] text-sm font-normal text-[#F67443]">
                {classBanner.description}
              </p>

              <div className="mt-[10px] w-full flex items-center justify-between">
                <div className="flex items-center">
                  <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

                  <ul className="flex items-center gap-x-[4px]">{languagesContent}</ul>
                </div>

                <div className="flex flex-column">
                  {/* TODO */}
                  <div className="flex items-center ml-auto">
                    <div className="flex items-center mr-[24px]">
                      <img src={'/assets/icon/globleIcon.png'} />
                      <img
                        src={`/assets/icon/britain.png`}
                        className="w-[24px] h-[24px] ml-[4px]"
                      />
                    </div>

                    <div className="flex items-center">
                      <img src={`/assets/icon/homeOrangeIcon.png`} />
                      <img src={`/assets/icon/poland.png`} className="w-[24px] h-[24px] ml-[4px]" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-[8px] flex items-center">
                <Icon name="hand-coin" color="#F79009" className="w-[24] h-[24px] mr-[8px]" />

                <ul className="flex items-center gap-x-[8px]">{currenciesContent}</ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-[10px] w-full flex items-center">
        <button
          className={`h-[40px] px-[16px] shadow-button rounded-[8px] border-[1px] text-sm font-semibold transition-colors duration-200 ease ${classBanner.active ? 'border-[#F79009] bg-[#FDFDFD] text-[#F79009] hover:text-white hover:bg-[#F79009]' : 'border-transparent text-white bg-[#1AC057] hover:bg-[#117b38]'}`}
          disabled={activateLoading}
          onClick={handleToggleActive}
        >
          {classBanner.active ? 'Deactivate' : 'Activate'}
        </button>

        <Link
          to={`/${role}/settings/my-banners/edit/${classBanner.classbanner_hash_1}`}
          className="group/edit ml-auto border-[#F67443] border-[1px] bg-[#FDFDFD] rounded-[6px] h-[40px] pl-[7px] pr-[16px] flex items-center hover:bg-[#F67443] transition-colors duration-200 ease"
        >
          <Icon
            name="edit-line"
            className="w-[16px] h-[16px] mr-[6px] text-[#F79009] group-hover/edit:text-white transition-colors duration-200 ease"
          />

          <span className="group-hover/edit:text-white text-primary-100 text-sm font-medium transition-colors duration-200 ease">
            Edit
          </span>
        </Link>

        <button
          disabled={isDeleteLoading}
          className={`ml-[10px] bg-[#EF4343] rounded-[6px] h-[40px] px-[16px] flex items-center hover:bg-[#ae0f0f] transition-all duration-200 ease ${isDeleteLoading ? 'opacity-70' : 'opacity-100'}`}
          onClick={handleDelete}
        >
          <Icon name="delete-bin-line" className="w-[24px] h-[24px] mr-[8px] text-white" />

          <span className="text-white text-sm font-medium">Delete</span>
        </button>
      </div>
    </div>
  )
}

export default ClassBannersActiveBanner
